const riot = require('riot');

riot.tag2('module-examination-result', '<div class="section-padding rounded-8 elevation-default-low bg-white"> <div class="mb36" data-is="module-section-header" title="審査結果"></div> <div class="ts-pm text-navy">{opts.distributionRule.review_reason}</div> </div>', 'module-examination-result,[data-is="module-examination-result"]{display:block}', '', function(opts) {
});